import { DeleteOutlined, EditOutlined, EyeOutlined } from '@ant-design/icons';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { FC } from 'react';
import { useState } from 'react';

import { PictureComponent } from 'app/components/commons/PictureComponent/PictureComponent';
import type { Picture } from 'app/components/commons/Uploader/Types';

import './UploadItem.scss';

export const UploadItem: FC<IProps> = ({
  item,
  onPreview,
  onRemove,
  onEdit,
  draggable,
  dndId,
}) => {
  const [isHover, setIsOver] = useState(false);

  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: dndId ?? '',
      disabled: !draggable || !dndId,
    });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={`upload-item ${draggable ? 'upload-item-sortable' : ''}`}
      {...(draggable ? attributes : {})}
      {...(draggable ? listeners : {})}
    >
      <div className="upload-item__thumbnail">
        <PictureComponent pictureId={item.pictureId} alt={item.alt} />
      </div>
      <div
        onMouseLeave={() => setIsOver(false)}
        onMouseOver={() => setIsOver(true)}
        className="upload-item__hover-area"
      >
        {!!isHover && (
          <div className="upload-item__hover-buttons">
            {!!onPreview && <EyeOutlined onClick={onPreview} />}
            {!!onEdit && <EditOutlined onClick={onEdit} />}
            {!!onRemove && <DeleteOutlined onClick={onRemove} />}
          </div>
        )}
      </div>
    </div>
  );
};

type IProps = {
  item: Picture;
  onPreview?: () => void;
  onRemove?: () => void;
  onEdit?: () => void;
  draggable?: boolean;
  dndId?: string;
};
